export default {
    address: "0x7b7c000000000000000000000000000000000015",
    abi: [
        {
            inputs: [],
            name: "decimals",
            outputs: [
                {
                    internalType: "uint8",
                    name: "",
                    type: "uint8",
                },
            ],
            stateMutability: "view",
            type: "function",
        },
        {
            inputs: [],
            name: "latestRoundData",
            outputs: [
                {
                    internalType: "uint80",
                    name: "roundId",
                    type: "uint80",
                },
                {
                    internalType: "int256",
                    name: "answer",
                    type: "int256",
                },
                {
                    internalType: "uint256",
                    name: "startedAt",
                    type: "uint256",
                },
                {
                    internalType: "uint256",
                    name: "updatedAt",
                    type: "uint256",
                },
                {
                    internalType: "uint80",
                    name: "answeredInRound",
                    type: "uint80",
                },
            ],
            stateMutability: "view",
            type: "function",
        },
    ],
};
//# sourceMappingURL=priceOracle.js.map